import { Card, Form, Info, Input, Select, Title } from 'components/common'
import config from 'config'
import { UnitCode } from 'lib/graphql/storeadmin'

export interface ProductPriceProps {
  price?: number
  specialPrice?: number
  unit?: UnitCode
  loading?: boolean
}

export const ProductPrice = ({
  price,
  specialPrice,
  unit,
  loading = false,
}: ProductPriceProps): JSX.Element => (
  <Card shadow loading={loading}>
    <Info title="料金発生単位に設定した単位ごとに発生する料金です。">
      <Title level={5} space="none">
        料金設定
      </Title>
    </Info>

    <div className="grid grid-cols-3 gap-x-8 mt-4">
      <div>
        <Form.Item
          label="通常料金"
          name={'price'}
          initialValue={price}
          rules={[
            { required: true, message: '通常料金は必須です。' },
            {
              type: 'number',
              min: 0,
              max: config.product.maxPrice,
              message: `0 以上 ${config.product.maxPrice} 以下の数値を入力してください。`,
              transform: (v) => Number(v),
            },
          ]}
        >
          <Input type="number" prefix={'￥'} />
        </Form.Item>
      </div>
      <div>
        <Form.Item
          label={
            <Info title="土日祝日料金が 0 の場合、通常料金が料金計算時に適用されます。">
              土日祝日料金
            </Info>
          }
          name="specialPrice"
          initialValue={specialPrice}
          rules={[
            { required: true, message: '土日祝日料金は必須です。' },
            {
              type: 'number',
              min: 0,
              max: config.product.maxPrice,
              message: `0 以上 ${config.product.maxPrice} 以下の数値を入力してください。`,
              transform: (v) => Number(v),
            },
          ]}
        >
          <Input type="number" prefix={'￥'} />
        </Form.Item>
      </div>
      <div>
        <Form.Item
          label={<Info title="明細に記載する単位です。">単位</Info>}
          name="unit"
          initialValue={unit || UnitCode.PerDay}
          rules={[{ required: true, message: '単位は必須です。' }]}
        >
          <Select
            options={[
              { label: '日', value: UnitCode.PerDay },
              { label: '時間', value: UnitCode.PerHour },
            ]}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </div>
    </div>
  </Card>
)
